import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Seller } from 'src/app/core/sellers.service';
import { SellersConfirmOtpDialogComponent } from 'src/app/sellers/sellers-confirm-otp-dialog/sellers-confirm-otp-dialog.component';

@Component({
  selector: 'app-seller-details-general-info',
  templateUrl: './seller-details-general-info.component.html',
  styleUrls: ['./seller-details-general-info.component.scss'],
})
export class SellerDetailsGeneralInfoComponent {
  @Input() seller?: Seller;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialog_service: DialogService, private error_service: ErrorService) {}
  onConfirmSellerClick() {
    this.dialog_service
      .openDialog(SellersConfirmOtpDialogComponent, {
        seller: this.seller,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
  getFullName(): string {
    if (this.seller) {
      const full_name = `${this.seller.firstname} ${this.seller.lastname}`;
      if (full_name.length > 30) {
        return full_name.slice(0, 27) + '...';
      } else {
        return full_name;
      }
    } else {
      return '-';
    }
  }

  getFormattedPhone(): string {
    if (!this.seller?.phone) {
      return '-';
    }

    return this.seller.phone.prefix + ' ' + this.seller.phone.value;
  }

  getCompanyName(): string {
    if (!this.seller?.company_business_name) {
      return '-';
    }

    if (this.seller.company_business_name.length > 30) {
      return this.seller.company_business_name.slice(0, 27) + '...';
    }

    return this.seller.company_business_name;
  }

  getBlockedReason(): string {
    if (!this.seller?.blocked_reason) {
      return '-';
    }

    if (this.seller.blocked_reason.toLowerCase().trim() === 'no reason provided') {
      return '-';
    }

    return this.seller.blocked_reason;
  }
}
